import {
  Autocomplete,
  Button,
  CircularProgress,
  MenuItem,
  TextField,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import DocumentTable from "../../../components/OB/BelgeYukleme";
import GayrimenkulBulPopUp from "../../../components/OB/PopUp";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import { araziBasvuruValidationSchema } from "../../../validations/EmlakBasvuru";
import AraziTuruAPI from "../../../apis/OB/Get/AraziTuruAPI";
import AraziBasvurusave from "../../../apis/OB/SaveApi/AraziBasvurusave";
import { safelyParseNumber } from "../../../helpers/MoneyFormat";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import SessionStorageService from "../../../services/StorageService";
import CustomTextField from "../../../components/OB/required-text-field";
import CustomDatePicker from "../../../components/OB/required-datepicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { filterOptions } from "../../../helpers/TodayDate";
import DysAPI from "../../../apis/DysAPI";
import Recaptcha from "../../../components/Recaptcha";
import { useFormConfig } from "../../../hooks/useFormConfig";
import ConfigurableField from "../../../components/OB/ConfigurableField";

const AraziBasvuru = () => {
  const recaptchaRef = useRef<any>(null);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupAciklama, setPopupAciklama] = useState("");
  const [kayitBasarili, setKayitBasarili] = useState(false);
  const [araziTuruList, setAraziTuruList] = useState<any[]>([]);
  const closePopupSonuc = () => {
    setIsPopupVisible(false);
    setPopupAciklama("");
  };
  const [documents, setDocuments] = useState<any[]>([]);
  const [docsLoaded, setDocsLoaded] = useState<boolean>(false);
  const documentTableRef = useRef<HTMLDivElement | null>(null);

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  // Dinamik Form Konfigurasyon Hook
  const { config, isFieldVisible, getFieldLabel, buildValidationSchema } = useFormConfig('ARAZI_BASVURU');

  const handleDecimalChange = (fieldName: string, value: string, setFieldValue: any) => {
    const formatted = value
      .replace(/[^0-9.]/g, "") // Rakamlar ve noktalar dışındaki karakterleri kaldır
      .replace(/^0+([1-9])/, "$1") // Başındaki gereksiz sıfırları kaldır
      .replace(/^0+\./, "0.") // 00. -> 0. düzelt
      .replace(/^[.]/, "0.") // Nokta ile başlarsa önüne 0 ekle
      .replace(/\./g, (match: any, i: any, original: any) =>
        i === original.indexOf(".") ? "." : ""
      ) // Yalnızca ilk noktayı bırak, diğerlerini sil
      .replace(/(\.\d{2})\d+/, "$1") // Ondalık noktadan sonra sadece iki basamak olacak şekilde sınırla
      .replace(/^-/, ""); // Negatif işareti kaldır

    setFieldValue(fieldName, formatted);
  };

  const handleDecimalBlur = (fieldName: string, value: string, setFieldValue: any) => {
    if (value && !value.includes(".")) {
      setFieldValue(fieldName, `${value}.00`);
    } else if (value && value.endsWith(".")) {
      setFieldValue(fieldName, `${value}00`);
    } else if (value && value.split(".")[1]?.length === 1) {
      setFieldValue(fieldName, `${value}0`);
    }
  };

  const handleUpdateDocuments = (updatedDocuments: any) => {
    setDocuments(updatedDocuments);
  };
  useEffect(() => {
    setDocsLoaded(false);

    DysAPI.obBasvuruTanimBelgeList({ rfObBasvuruTanim: 3 })
      .then((res: any) => {
        console.log("Belge listesi response:", res.data);

        const list = (res?.data ?? []).map((b: any, idx: number) => {
          const zorunlu = (b.zorunluEh)
            .toString();

          return {
            id: b.sqId,
            documentName: b.belgeAdi,
            isRequired: ["E"].includes(zorunlu),
            fileName: "",
            file: null,
          };
        });


        setDocuments(list);
      })
      .catch((err: any) => {
        console.error("Belge listesi hatası:", err);
        setDocuments((prevDocs: any[]) =>
          prevDocs.map((doc) => ({
            ...doc,
            file: null,
            fileName: "",
          }))
        );
      })
      .finally(() => {
        setDocsLoaded(true);
      });
  }, []);
  const [selectedMahalleKodu, setSelectedMahalleKodu] = useState<number | null>(null);
  const [caddeListe, setCaddeListe] = useState<any[]>([]);
  const { mahalleListe } = useContext(ConstantAPISContext);
  const [open, setOpen] = useState(false);
  const user = SessionStorageService.getUserInfo()
  const openPopup = () => {
    setOpen(true);
  };

  const closePopup = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (selectedMahalleKodu) {
      CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalleKodu)
        .then((res) => {
          setCaddeListe(res.data);
        })
        .catch(() => {
          console.log("hata");
        });
    } else {
      setCaddeListe([]);
    }
  }, [selectedMahalleKodu]);

  useEffect(() => {
    AraziTuruAPI.getAraziTuruiste(undefined).then((res) => {
      setAraziTuruList(res.data);
    })
      .catch(() => {
        console.log("hata");
      });
  }, []);

  return (

    <Formik
      initialValues={{
        basvuruTuruId: 3,
        mahalleKodu: '',
        caddeSokakKodu: '',
        mevki: '',
        pafta: '',
        ada: '',
        parsel: '',
        tapuCiltNo: '',
        tapuSayfaNo: '',
        tapuYevmiyeNo: '',
        tapuYevmiyeTarihi: null,
        araziYuzolcumu: '',
        araziHisse: '',
        araziOran: '',
        arazi2Hisse: '1.00',
        arazi2Oran: '1.00',
        hisseyeDusenAraziYuzolcumu: '',
        araziTuru: '',
        pismanlikIndirimi: '',
        imarPlanNo: '',
        edinmeTarihi: null,
        aciklama: '',
      }}
      validateOnMount={true}
      validationSchema={buildValidationSchema(araziBasvuruValidationSchema)}
      onSubmit={async (values: any, { resetForm }) => {
        const missingDocuments = documents
          .filter(doc => doc.isRequired) // zorunlu belgeler
          .filter(doc => !doc.fileName);     // henüz yüklenmemiş olanlar

        if (missingDocuments.length > 0) {
          const missingDocNames = missingDocuments.map(d => d.documentName).join(", ");
          toast.error(`Lütfen şu zorunlu belgeleri yükleyin: ${missingDocNames}`);
          documentTableRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
          return; // başvuru burada durur
        }

        // reCAPTCHA’yı tetikle
        const token = await recaptchaRef.current?.handleSubmit();
        if (!token) {
          toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
          return;
        }
        setLoadingSubmit(true);
        const formattedValues = {
          ...values,
          ada: values.ada != "" ? safelyParseNumber(values.ada) : null,
          parsel: values.parsel != "" ? safelyParseNumber(values.parsel) : null,
          tapuCiltNo: values.tapuCiltNo != "" ? safelyParseNumber(values.tapuCiltNo) : null,
          tapuSayfaNo: values.tapuSayfaNo != "" ? safelyParseNumber(values.tapuSayfaNo) : null,
          araziYuzolcumu: safelyParseNumber(values.araziYuzolcumu),
          araziHisse: safelyParseNumber(values.araziHisse),
          araziOran: safelyParseNumber(values.araziOran),
          arazi2Oran: safelyParseNumber(values.arazi2Oran),
          arazi2Hisse: safelyParseNumber(values.arazi2Hisse),
          hisseyeDusenAraziYuzolcumu: safelyParseNumber(values.hisseyeDusenAraziYuzolcumu),
          edinmeTarihi: values.edinmeTarihi != null ? dayjs(values.edinmeTarihi).tz("Europe/Istanbul").format("YYYY-MM-DD") : null,
          tapuYevmiyeTarihi: values.tapuYevmiyeTarihi != null ? dayjs(values.tapuYevmiyeTarihi).tz("Europe/Istanbul").format("YYYY-MM-DD") : null,
          sicilKodu: safelyParseNumber(user.sicilKodu) || 0,
          captchaToken: token

        };
        AraziBasvurusave.saveAraziBasvuruSave(formattedValues)
          .then(async (res) => {
            if (res.data.sonuc === 0) {
              let basvuruNo = res.data.basvuruNo;

              // DYS API'yi çağır 
              try {
                // Sadece dosyası olanları al
                const filesToSend = documents.filter((doc: any) => !!doc.file);

                if (filesToSend.length > 0) {
                  const formData = new FormData();

                  filesToSend.forEach((doc: any) => {
                    formData.append("files", doc.file, doc.file.name);
                    formData.append("rfObBasvuruTanimBelge", String(doc.id));
                  });

                  formData.append("basvuruTuru", String(values.basvuruTuruId || 0));
                  formData.append("basvuruId", String(basvuruNo));
                  formData.append("folderName", "AKOS");
                  formData.append("kurumId", "1");
                  formData.append("versionable", "1");

                  const response = await DysAPI.upload(formData);
                  toast.warning(response.message);
                } else {
                  // Burada return yok — sadece DYS çağrısını atlıyoruz.
                }
              } catch (error: any) {
                toast.error("DYS upload hazırlama hatası:", error);
              }

              setPopupAciklama("İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " + basvuruNo);
              resetForm();
              setDocuments((prevDocs: any[]) =>
                prevDocs.map((doc) => ({
                  ...doc,
                  file: null,
                  fileName: "",
                }))
              );
              setKayitBasarili(true);
            } else {
              setPopupAciklama(res.data.sonucAciklama);
            }
          })
          .catch(() => {
            setPopupAciklama(
              "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
            );
          })
          .finally(() => {
            setIsPopupVisible(true);
            recaptchaRef.current?.reset();
            setLoadingSubmit(false);
          });
      }}

    >

      {(formikProps) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          console.log('Formik Errors:', formikProps.errors);
        }, [formikProps.errors]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          if (
            formikProps.values.araziOran !== "" &&
            formikProps.values.araziHisse !== "" &&
            formikProps.values.araziYuzolcumu !== ""
          ) {
            let result =
              Number(formikProps.values.araziYuzolcumu) *
              (Number(formikProps.values.araziHisse) /
                Number(formikProps.values.araziOran))
              * (Number(formikProps.values.arazi2Hisse || 1.00) /
                Number(formikProps.values.arazi2Oran || 1.00));
            formikProps.setFieldValue(
              "hisseyeDusenAraziYuzolcumu",
              result.toString()
            );
          }
        }, [formikProps.values.araziOran, formikProps.values.araziHisse, formikProps.values.araziYuzolcumu, formikProps.values.arazi2Hisse, formikProps.values.arazi2Oran]);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        const showToastIfErrorsExist = () => {
          if (Object.keys(formikProps.errors).length > 0) {
            toast.error("Lütfen zorunlu alanları doldurun!");
            focusFirstErrorField();


          }
        };
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const formRefs = useRef<any>({});
        const focusFirstErrorField = () => {
          const errorKeys = Object.keys(formikProps.errors);
          if (errorKeys.length > 0) {
            const firstErrorKey = errorKeys[0];
            console.log(errorKeys[0])
            const element = document.querySelector(`[name="${firstErrorKey}"]`);
            if (element) {
              (element as HTMLElement).focus();
            }
          }
        };
        return (
          <Form onSubmit={formikProps.handleSubmit}>
            <div className="row">
              <div className="col-12 mb-2">
                <div className="d-flex justify-content-between align-self-stretch">
                  <Button color="warning" onClick={openPopup} type="button" >
                    Gayrimenkul Bul
                  </Button>
                  <Button
                    type="button"
                    onClick={() => {
                      formikProps.resetForm({ values: formikProps.initialValues });
                      setDocuments((prevDocs: any[]) =>
                        prevDocs.map((doc) => ({
                          ...doc,
                          file: null,
                          fileName: "",
                        }))
                      );
                    }}
                    color="secondary"
                  >
                    Temizle
                  </Button>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-3 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">
                      <ConfigurableField fieldName="mahalleKodu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="mahalleKodu"
                          fullWidth
                          className="mb-3"
                          select
                          label={getFieldLabel("mahalleKodu", "Mahalle *")}
                          size="small"
                          value={formikProps.values.mahalleKodu}
                          onChange={(value: any) => {
                            formikProps.setFieldValue("mahalleKodu", Number(value.target.value));
                            setSelectedMahalleKodu(Number(value.target.value));
                            formikProps.setFieldValue("caddeSokakKodu", '');
                          }}
                          error={
                            formikProps.errors.mahalleKodu && formikProps.touched.mahalleKodu
                              ? true
                              : false
                          }
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {mahalleListe.map((option) => (
                            <MenuItem key={option.mahalleKodu} value={option.mahalleKodu}>
                              {option.mahalleAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="caddeSokakKodu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="caddeSokakKodu"
                          fullWidth
                          className="mb-3"
                          size="small"
                          select
                          label={getFieldLabel("caddeSokakKodu", "Cadde/Sokak *")}
                          value={formikProps.values.caddeSokakKodu}
                          onChange={(value: any) =>
                            formikProps.setFieldValue("caddeSokakKodu", Number(value.target.value))
                          }
                          error={
                            formikProps.errors.caddeSokakKodu &&
                              formikProps.touched.caddeSokakKodu
                              ? true
                              : false
                          }
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {caddeListe.map((option) => (
                            <MenuItem key={option.caddeSokakKodu} value={option.caddeSokakKodu}>
                              {option.caddeSokakAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      </ConfigurableField>
                    </div>

                    <div className="row">
                      <ConfigurableField fieldName="mevki" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("mevki", "Mevkii *")}
                          {...formikProps.getFieldProps("mevki")}
                          variant="outlined"
                          error={
                            formikProps.errors.mevki && formikProps.touched.mevki ? true : false
                          }
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="pafta" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("pafta", "Pafta *")}
                          {...formikProps.getFieldProps("pafta")}
                          variant="outlined"
                          error={
                            formikProps.errors.pafta && formikProps.touched.pafta ? true : false
                          }
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="ada" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="ada"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("ada", "Ada *")}
                          value={formikProps.values.ada}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("ada", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 10) : "")
                          }
                          variant="outlined"
                          error={formikProps.errors.ada && formikProps.touched.ada ? true : false}
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="parsel" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="parsel"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("parsel", "Parsel *")}
                          value={formikProps.values.parsel}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("parsel", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 10) : "")
                          }
                          variant="outlined"
                          error={
                            formikProps.errors.parsel && formikProps.touched.parsel ? true : false
                          }
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="tapuCiltNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6 mb-3 mb-lg-0">
                        <TextField
                          fullWidth
                          size="small"
                          label={getFieldLabel("tapuCiltNo", "Tapu Cilt No")}
                          value={formikProps.values.tapuCiltNo}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("tapuCiltNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 7) : "")
                          }
                          variant="outlined"
                          error={
                            formikProps.errors.tapuCiltNo && formikProps.touched.tapuCiltNo
                              ? true
                              : false
                          }
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="tapuSayfaNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6 mb-3 mb-lg-0">
                        <TextField
                          fullWidth
                          size="small"
                          label={getFieldLabel("tapuSayfaNo", "Tapu Sayfa No")}
                          value={formikProps.values.tapuSayfaNo}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("tapuSayfaNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 7) : "")
                          }
                          variant="outlined"
                          error={
                            formikProps.errors.tapuSayfaNo && formikProps.touched.tapuSayfaNo
                              ? true
                              : false
                          }
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">
                      <ConfigurableField fieldName="tapuYevmiyeNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("tapuYevmiyeNo", "Tapu Yevmiye No")}
                          {...formikProps.getFieldProps("tapuYevmiyeNo")}
                          variant="outlined"
                          error={
                            formikProps.errors.tapuYevmiyeNo &&
                              formikProps.touched.tapuYevmiyeNo
                              ? true
                              : false
                          }
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="tapuYevmiyeTarihi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <DatePicker
                          label={getFieldLabel("tapuYevmiyeTarihi", "Tapu Yevmiye Tarihi")}
                          className="mb-3"
                          value={formikProps.values.tapuYevmiyeTarihi}
                          onChange={(value) =>
                            formikProps.setFieldValue("tapuYevmiyeTarihi", value)
                          }
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              error:
                                formikProps.errors.tapuYevmiyeTarihi &&
                                  formikProps.touched.tapuYevmiyeTarihi
                                  ? true
                                  : false,
                            },
                          }}
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="araziYuzolcumu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="araziYuzolcumu"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("araziYuzolcumu", "Arazi Yüz Ölçümü *")}
                          value={formikProps.values.araziYuzolcumu}
                          onChange={(e: any) =>
                            handleDecimalChange("araziYuzolcumu", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("araziYuzolcumu", e.target.value, formikProps.setFieldValue)
                          }
                          variant="outlined"
                          error={
                            formikProps.errors.araziYuzolcumu &&
                              formikProps.touched.araziYuzolcumu
                              ? true
                              : false
                          }
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="araziHisse" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="araziHisse"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("araziHisse", "Arazi Hisse *")}
                          value={formikProps.values.araziHisse}
                          onChange={(e: any) =>
                            handleDecimalChange("araziHisse", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("araziHisse", e.target.value, formikProps.setFieldValue)
                          }
                          variant="outlined"
                          error={
                            formikProps.errors.araziHisse && formikProps.touched.araziHisse
                              ? true
                              : false
                          }
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="araziOran" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="araziOran"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("araziOran", "Arazi Oran *")}
                          value={formikProps.values.araziOran}
                          onChange={(e: any) =>
                            handleDecimalChange("araziOran", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("araziOran", e.target.value, formikProps.setFieldValue)
                          }
                          variant="outlined"
                          error={
                            formikProps.errors.araziOran && formikProps.touched.araziOran
                              ? true
                              : false
                          }
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="arazi2Hisse" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("arazi2Hisse", "Arazi 2. Hisse")}
                          value={formikProps.values.arazi2Hisse || "1.00"}
                          onChange={(e: any) =>
                            handleDecimalChange("arazi2Hisse", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("arazi2Hisse", e.target.value, formikProps.setFieldValue)
                          }
                          variant="outlined"
                          error={
                            formikProps.errors.arazi2Hisse && formikProps.touched.arazi2Hisse
                              ? true
                              : false
                          }
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row mb-3 mb-lg-0">
                      <ConfigurableField fieldName="arazi2Oran" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          size="small"
                          label={getFieldLabel("arazi2Oran", "Arazi 2. Oran")}
                          value={formikProps.values.arazi2Oran || "1.00"}
                          onChange={(e: any) =>
                            handleDecimalChange("arazi2Oran", e.target.value, formikProps.setFieldValue)
                          }
                          onBlur={(e: any) =>
                            handleDecimalBlur("arazi2Oran", e.target.value, formikProps.setFieldValue)
                          }
                          className="pb-2 pb-lg-0"
                          variant="outlined"
                          error={
                            formikProps.errors.arazi2Oran && formikProps.touched.arazi2Oran
                              ? true
                              : false
                          }
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="hisseyeDusenAraziYuzolcumu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          size="small"
                          label={getFieldLabel("hisseyeDusenAraziYuzolcumu", "Hisseye Düşen Arazi Yüzölçümü")}
                          {...formikProps.getFieldProps("hisseyeDusenAraziYuzolcumu")}
                          variant="outlined"
                          error={
                            formikProps.errors.hisseyeDusenAraziYuzolcumu &&
                              formikProps.touched.hisseyeDusenAraziYuzolcumu
                              ? true
                              : false
                          }
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mt-sm-2 mt-xxl-0 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">
                      <ConfigurableField fieldName="araziTuru" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          fullWidth
                          className="mb-3"
                          select
                          label={getFieldLabel("araziTuru", "Arazi Türü *")}
                          {...formikProps.getFieldProps("araziTuru")}
                          size="small"
                          error={
                            formikProps.errors.araziTuru && formikProps.touched.araziTuru
                              ? true
                              : false
                          }
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {araziTuruList.map((option: any) => (
                            <MenuItem key={option.araziTurKodu} value={option.araziTurKodu}>
                              {option.araziTurAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="pismanlikIndirimi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          select
                          label={getFieldLabel("pismanlikIndirimi", "Pişmanlık İndirimi")}
                          {...formikProps.getFieldProps("pismanlikIndirimi")}
                          size="small"
                          error={
                            formikProps.errors.pismanlikIndirimi &&
                              formikProps.touched.pismanlikIndirimi
                              ? true
                              : false
                          }
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          <MenuItem selected value={"E"}>
                            {"Evet"}
                          </MenuItem>
                          <MenuItem selected value={"H"}>
                            {"Hayır"}
                          </MenuItem>
                        </TextField>
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="imarPlanNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6 ">
                        <TextField
                          fullWidth
                          size="small"
                          label={getFieldLabel("imarPlanNo", "İmar Plan No")}
                          {...formikProps.getFieldProps("imarPlanNo")}
                          className="pb-2 pb-lg-0"
                          variant="outlined"
                          error={
                            formikProps.errors.imarPlanNo && formikProps.touched.imarPlanNo
                              ? true
                              : false
                          }
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="edinmeTarihi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomDatePicker
                          name="edinmeTarihi"
                          slotProps={{
                            textField: {
                              size: "small", fullWidth: true,
                              error:
                                formikProps.errors.edinmeTarihi &&
                                  formikProps.touched.edinmeTarihi
                                  ? true
                                  : false,
                            },
                          }}
                          label={getFieldLabel("edinmeTarihi", "Edinme Tarihi *")}
                          value={formikProps.values.edinmeTarihi}
                          onChange={(value: any) => formikProps.setFieldValue("edinmeTarihi", value)}
                          className="mb-3"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="aciklama" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="row pe-0">
                        <div className="col-12 pe-0">
                          <TextField
                            id="outlined-multiline-flexible"
                            label={getFieldLabel("aciklama", "Açıklama")}
                            {...formikProps.getFieldProps("aciklama")}
                            error={
                              formikProps.errors.aciklama && formikProps.touched.aciklama
                                ? true
                                : false
                            }
                            rows={2.75}
                            fullWidth
                            multiline
                            maxRows={10}
                          />
                        </div>
                      </div>
                      </ConfigurableField>
                    </div>
                  </div>
                </div>
              </div>
              <div ref={documentTableRef}>
                {!docsLoaded ? (
                  <div className="d-flex justify-content-center my-2"><CircularProgress size={24} /></div>
                ) : (
                  <DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} />
                )}
              </div>
              <div className="col-12 mt-3">
                <div className="d-flex justify-content-end align-self-stretch">
                  <Recaptcha
                    ref={recaptchaRef}
                    changeHandleRecaptcha={setRecaptchaPassed}
                  />
                  <Button
                    onClick={() => showToastIfErrorsExist()}
                    type="submit"
                  >
                    Gönder
                  </Button>
                  {loadingSubmit && (
                    <div
                      style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(255,255,255,0.6)",
                        zIndex: 1300,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  )}
                </div>
              </div>
              {open && (
                <GayrimenkulBulPopUp
                  onSelectEmlak={(emlak: any) => {
                    if (emlak) {
                      formikProps.setFieldValue("pafta", emlak.pafta);
                      formikProps.setFieldValue("ada", emlak.ada);
                      formikProps.setFieldValue("parsel", emlak.parsel);
                      formikProps.setFieldValue("mahalleKodu", emlak.mahalleKodu);
                      setSelectedMahalleKodu(emlak.mahalleKodu)
                      formikProps.setFieldValue("caddeSokakKodu", emlak.caddeSokakKodu);
                      closePopup();
                    }
                  }}
                  open={open}
                  onClose={setOpen}
                  type="3"
                />
              )}
              {isPopupVisible && (
                <BilgilendirmePopup
                  basvuruTuruId={formikProps.values.basvuruTuruId}
                  isSorunBildirPopup={!kayitBasarili}
                  closePopup={closePopupSonuc}
                  open={isPopupVisible}
                  editDescription={popupAciklama}
                />
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AraziBasvuru;